import availabilitiesCoaching from './availabilitiesCoaching'
import availabilitiesTherapy from './availabilitiesTherapy'
import genders from './gender'
import lgbtqia from './lgbtqia'
import meetingSettingCoaching from './meetingSettingCoaching'
import meetingSettingTherapy from './meetingSettingTherapy'
import raceEthnicityCoaching from './raceEthnicityCoaching'
import raceEthnicityTherapy from './raceEthnicityTherapy'
import religion from './religion'
import veterans from './veteran'

// The active set of preferences we currently surface across all MP workflows
export const activeMemberPreferenceListOptions = [
  genders,
  availabilitiesCoaching,
  availabilitiesTherapy,
  raceEthnicityCoaching,
  raceEthnicityTherapy,
  lgbtqia,
  religion,
  veterans,
  meetingSettingTherapy,
  meetingSettingCoaching,
]

export const ousMemberPreferenceListOptionsV1 = [meetingSettingTherapy]

export const ousMemberPreferenceListOptionsV2 = [
  genders,
  raceEthnicityTherapy,
  lgbtqia,
  veterans,
  meetingSettingTherapy,
]

export const getAvailableMemberPreferenceListOptions = ({
  isUserInternational,
  areExpandedGlobalPreferencesEnabled,
}: {
  isUserInternational: boolean
  areExpandedGlobalPreferencesEnabled: boolean
}) => {
  if (!isUserInternational) {
    return activeMemberPreferenceListOptions
  }

  return areExpandedGlobalPreferencesEnabled ? ousMemberPreferenceListOptionsV2 : ousMemberPreferenceListOptionsV1
}
